export const NT_REMOVE = 'NT_REMOVE'
export const NT_CLEANUP = 'NT_CLEANUP'

export const notificationsRemove = (notificationId) => ({
  payload: notificationId,
  type: NT_REMOVE,
})

export const notificationsCleanUp = () => ({
  payload: null,
  type: NT_CLEANUP,
})
